import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const fetchFeeItems = (feeId) => {
    return function(dispatch) {
        return axios(apiRequestOptions(apiPath.FEE_ITEMS.LIST, { competitionFee: feeId }))
            .then(transformHttpResponse)
            .then(response => Array.isArray(response.data) ? response.data : [])
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(errorRequestHandler(error));
                return [];
            });
    }
};
